import { SLAStatus } from "../../Enums";

export const fields = {
  slaStatusID: {
    label: "SLA Status",
    rules: "required",
    value: SLAStatus.NotStarted,
  },
  companyRelationshipManagerID: {
    label: "Primary Relationship Holder",
    rules: "required",
    value: null,
  },
  slaExpiryDate: {
    label: "SLA Expiry Date",
    value: null,
  },
  priceReviewDate: {
    label: "Price Review Date",
    value: null,
  },
  slaReminderDate: {
    label: "Reminder Date",
    value: null,
  },
  slaReminderSentTo: {
    label: "Reminder To Be Sent To",
    value: null,
  }
};
